import React from 'react';

import { PublicClientApplication, EventType, AuthenticationResult } from '@azure/msal-browser';
import * as Sentry from '@sentry/react';
import * as log from 'loglevel';
import ReactDOM from 'react-dom/client';

import App from './App';
import { msalConfig } from './authConfig';
import { logConfig } from './config';
import { sentry } from './config';
import reportWebVitals from './reportWebVitals';

log.setLevel((logConfig.logLevel || 'WARN') as log.LogLevelDesc);

Sentry.init(sentry);

const msalInstance = new PublicClientApplication(msalConfig);

if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
  msalInstance.setActiveAccount(msalInstance.getActiveAccount());
}

msalInstance.addEventCallback(event => {
  if (
    event.eventType === EventType.LOGIN_SUCCESS ||
    event.eventType === EventType.SSO_SILENT_SUCCESS
  ) {
    const payload = event.payload as AuthenticationResult;
    if (payload.account) {
      msalInstance.setActiveAccount(payload.account);
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
    <React.StrictMode>
      <App instance={msalInstance} />
    </React.StrictMode>
  </Sentry.ErrorBoundary>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
